/* Quboom theme: cart drawer (Shopify AJAX cart + Section Rendering), menus and email forms.
   window.theme is set in layout/theme.liquid. */
(() => {
  const T = window.theme || { routes: {}, strings: {} };
  // Strings come from Liquid's t filter, which HTML-escapes them (didn&#39;t); decode once for textContent.
  const unescape = s => { const t = document.createElement("textarea"); t.innerHTML = s; return t.value; };
  for (const k in T.strings) if (typeof T.strings[k] === "string") T.strings[k] = unescape(T.strings[k]);
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)");

  // ---------- Money: follows the shop's money format ----------
  function money(cents) {
    const fmt = T.moneyFormat || "${{amount}}";
    const n = (cents || 0) / 100;
    const group = (num, dec, thou, sep) => {
      const [i, d] = num.toFixed(dec).split(".");
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? sep + d : "");
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: group(n, 2, ",", "."),
      amount_no_decimals: group(n, 0, ",", "."),
      amount_with_comma_separator: group(n, 2, ".", ","),
      amount_no_decimals_with_comma_separator: group(n, 0, ".", ","),
      amount_with_apostrophe_separator: group(n, 2, "'", "."),
    }[k] ?? group(n, 2, ",", ".")));
  }

  // ---------- Feedback ----------
  function toast(msg) {
    const t = $(".toast");
    if (!t) return;
    t.textContent = msg; t.classList.add("is-visible");
    clearTimeout(toast.t); toast.t = setTimeout(() => t.classList.remove("is-visible"), 2600);
  }
  // Screen-reader only status, for feedback that is already visible on the button itself
  function announce(msg) {
    let s = $("[data-announce]");
    if (!s) {
      s = document.createElement("p"); s.className = "visually-hidden";
      s.setAttribute("role", "status"); s.dataset.announce = ""; document.body.append(s);
    }
    s.textContent = ""; setTimeout(() => { s.textContent = msg; }, 50);
  }
  // Add-to-cart feedback: the button itself confirms, then returns to normal
  function added(btn) {
    btn.dataset.label ??= btn.textContent.trim();
    btn.textContent = T.strings.added; btn.classList.add("is-added");
    clearTimeout(btn.t);
    btn.t = setTimeout(() => { btn.textContent = btn.dataset.label; btn.classList.remove("is-added"); }, 1600);
  }

  // ---------- Cart ----------
  async function post(url, body) {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ ...body, sections: "cart-drawer", sections_url: location.pathname }),
    });
    const json = await res.json();
    if (!res.ok) throw new Error(json.description || json.message || T.strings.error);
    return json;
  }

  let lastCount = +($("[data-cart-drawer]")?.dataset.count || 0);

  // Swap in the re-rendered drawer. The meter bar is kept and only its --p changes, so the roll travels.
  // The summary (subtotal or the two split-checkout buttons) is swapped whole; the payment buttons are only shown or hidden.
  function renderDrawer(html) {
    if (!html) return;
    const next = new DOMParser().parseFromString(html, "text/html");
    const drawer = $("[data-cart-drawer]");
    const src = $("[data-cart-drawer]", next);
    if (!drawer || !src) return;

    $("[data-cart-body]", drawer).innerHTML = $("[data-cart-body]", src).innerHTML;
    const sum = $("[data-cart-summary]", drawer), nextSum = $("[data-cart-summary]", src);
    if (sum && nextSum) sum.innerHTML = nextSum.innerHTML;

    const meter = $(".ship-meter", drawer), nextMeter = $(".ship-meter", src);
    if (meter && nextMeter) {
      const bar = $(".ship-meter__bar", meter), nextBar = $(".ship-meter__bar", nextMeter);
      bar.style.setProperty("--p", nextBar.style.getPropertyValue("--p"));
      bar.classList.toggle("is-full", nextBar.classList.contains("is-full"));
      $("[data-ship-text]", meter).textContent = $("[data-ship-text]", nextMeter).textContent.trim();
      meter.hidden = nextMeter.hidden;
    }

    const pay = $("[data-cart-pay]", drawer), nextPay = $("[data-cart-pay]", src);
    if (pay && nextPay) pay.hidden = nextPay.hidden;

    const count = +src.dataset.count;
    drawer.dataset.count = count;
    setCount(count);
  }

  function setCount(count) {
    $$("[data-cart-count]").forEach(el => {
      el.textContent = count; el.hidden = count === 0;
      // The count nudges when something is added, so the eye finds the cart
      if (count > lastCount && !reduceMotion.matches) {
        el.classList.remove("is-bump"); void el.offsetWidth; el.classList.add("is-bump");
      }
    });
    lastCount = count;
  }

  async function addToCart(items, btn, title) {
    btn && (btn.disabled = true, btn.setAttribute("aria-busy", "true"));
    try {
      const json = await post(T.routes.cartAdd + ".js", { items });
      renderDrawer(json.sections && json.sections["cart-drawer"]);
      if (btn) added(btn);
      if (title) announce(T.strings.addedTo.replace("[title]", title));
      return true;
    } catch (err) {
      toast(err.message || T.strings.error);
      return false;
    } finally {
      btn && (btn.disabled = false, btn.removeAttribute("aria-busy"));
    }
  }

  async function changeLine(key, quantity) {
    const body = $("[data-cart-body]");
    body && body.setAttribute("aria-busy", "true");
    try {
      const json = await post(T.routes.cartChange + ".js", { id: key, quantity });
      renderDrawer(json.sections && json.sections["cart-drawer"]);
    } catch (err) {
      toast(err.message || T.strings.error);
    } finally {
      body && body.removeAttribute("aria-busy");
    }
  }

  // ---------- Drawer ----------
  let lastFocus;
  function openDrawer() {
    const d = $("#cart-drawer");
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add("is-open"); d.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("has-drawer");
    $(".drawer__close", d).focus();
  }
  function closeDrawer() {
    const d = $("#cart-drawer");
    if (!d || !d.classList.contains("is-open")) return;
    d.classList.remove("is-open"); d.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("has-drawer");
    lastFocus && lastFocus.focus();
  }
  // Keep Tab inside the open drawer
  function trapFocus(e) {
    const d = $("#cart-drawer.is-open");
    if (!d || e.key !== "Tab") return;
    const f = $$("a[href], button:not([disabled]), input, select", d).filter(el => el.offsetParent);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  // ---------- Menus: open on hover with a mouse, on click or Enter otherwise ----------
  const menus = $$(".nav__item");
  const hoverMenus = matchMedia("(hover: hover) and (min-width: 1101px)");
  function setMenu(item, open) {
    item.classList.toggle("is-open", open);
    $(".nav__trigger", item).setAttribute("aria-expanded", open);
  }
  const closeMenus = except => menus.forEach(m => m !== except && setMenu(m, false));
  menus.forEach(item => {
    let t;
    item.addEventListener("mouseenter", () => {
      if (!hoverMenus.matches) return;
      clearTimeout(t); closeMenus(item); setMenu(item, true);
    });
    item.addEventListener("mouseleave", () => {
      if (!hoverMenus.matches) return;
      t = setTimeout(() => setMenu(item, false), 150);
    });
  });
  function setNav(open) {
    const nav = $(".nav"), toggle = $(".menu-toggle");
    if (!nav || !toggle || nav.classList.contains("is-open") === open) return;
    nav.classList.toggle("is-open", open);
    toggle.setAttribute("aria-expanded", open);
    if (!open) closeMenus();
  }

  // ---------- Clicks ----------
  document.addEventListener("click", e => {
    if (!e.target.closest(".nav__item")) closeMenus();

    const trig = e.target.closest(".nav__trigger");
    if (trig) {
      const item = trig.parentElement;
      // A mouse click on an already-hovered menu keeps it open; keyboard and touch toggle it
      const open = hoverMenus.matches && e.detail > 0 ? true : !item.classList.contains("is-open");
      closeMenus(item); setMenu(item, open); return;
    }

    const q = e.target.closest("[data-quick]");
    if (q) { addToCart([{ id: +q.dataset.quick, quantity: 1 }], q, q.dataset.title); return; }

    const k = e.target.closest("[data-checkout-kind]");
    if (k) { splitCheckout(k.dataset.checkoutKind, k); return; }

    const c = e.target.closest("[data-change]");
    if (c) { changeLine(c.dataset.change, Math.max(0, +c.dataset.qty)); return; }

    if (e.target.closest("[data-open-cart]") && $("#cart-drawer")) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest("[data-close-cart]")) { closeDrawer(); return; }

    const m = e.target.closest(".menu-toggle");
    if (m) setNav(!$(".nav").classList.contains("is-open"));
    // A tap on the page behind the open mobile menu closes it
    else if (!e.target.closest(".nav")) setNav(false);
  });

  document.addEventListener("keydown", e => {
    trapFocus(e);
    if (e.key !== "Escape") return;
    if ($("#cart-drawer.is-open")) { closeDrawer(); return; }
    const open = menus.find(m => m.classList.contains("is-open"));
    if (open) { setMenu(open, false); $(".nav__trigger", open).focus(); return; }
    if ($(".nav.is-open")) { setNav(false); $(".menu-toggle").focus(); }
  });

  // ---------- Product form: add without leaving the page, then open the drawer ----------
  // The sticky bar's button submits this form through its form attribute, so feedback goes to e.submitter.
  // Line item properties (the pre-order arrival date) are sent along.
  $$("[data-product-form]").forEach(form => form.addEventListener("submit", async e => {
    e.preventDefault();
    const data = new FormData(form);
    const btn = e.submitter || $("[type=submit][name=add]", form);
    const item = { id: +data.get("id"), quantity: Math.max(1, +data.get("quantity") || 1) };
    for (const [k, v] of data) {
      const m = /^properties\[(.+)\]$/.exec(k);
      if (m && v !== "") (item.properties ||= {})[m[1]] = v;
    }
    const plan = data.get("selling_plan");
    if (plan) item.selling_plan = +plan;
    const ok = await addToCart([item], btn, form.dataset.title);
    if (ok) openDrawer();
  }));

  // ---------- Split checkout ----------
  // In-stock and pre-order tape check out separately. Checking out one group stashes the other group's lines
  // in localStorage, sets them to 0 and goes to checkout. The next time the shopper loads a store page
  // (order placed or checkout left), the stash is added back.
  const STASH = "quboom:cart-stash";
  const STASH_DAYS = 14;
  const getJSON = async url => {
    const res = await fetch(url, { headers: { Accept: "application/json" } });
    if (!res.ok) throw new Error(T.strings.error);
    return res.json();
  };
  // A stash older than two weeks is dropped: the shopper has moved on
  function parseStash(raw) {
    try {
      const s = JSON.parse(raw);
      if (!s || !Array.isArray(s.items) || Date.now() - s.at > STASH_DAYS * 864e5) return null;
      return s;
    } catch { return null; }
  }
  const toStash = i => ({
    id: i.variant_id,
    quantity: i.quantity,
    ...(i.properties && Object.keys(i.properties).length ? { properties: i.properties } : {}),
    ...(i.selling_plan_allocation ? { selling_plan: i.selling_plan_allocation.selling_plan.id } : {}),
  });

  async function splitCheckout(kind, btn) {
    const kinds = {};
    $$("[data-line][data-kind]").forEach(el => { kinds[el.dataset.line] = el.dataset.kind; });
    const before = localStorage.getItem(STASH);
    btn.disabled = true; btn.setAttribute("aria-busy", "true");
    try {
      // On the /cart page, save typed quantities first
      const page = btn.closest("[data-cart-page]");
      if (page) {
        const updates = {};
        $$("input[name^='updates[']", page).forEach(inp => {
          updates[inp.name.slice(8, -1)] = Math.max(0, parseInt(inp.value, 10) || 0);
        });
        await post(T.routes.cartUpdate + ".js", { updates });
      }
      const cart = await getJSON(T.routes.cart + ".js");
      const others = cart.items.filter(i => kinds[i.key] && kinds[i.key] !== kind);
      const going = cart.items.filter(i => !others.includes(i));
      if (!going.length) { location.reload(); return; }
      if (others.length) {
        const prev = parseStash(before);
        localStorage.setItem(STASH, JSON.stringify({
          at: Date.now(),
          items: [...(prev ? prev.items : []), ...others.map(toStash)],
        }));
        await post(T.routes.cartUpdate + ".js", { updates: Object.fromEntries(others.map(i => [i.key, 0])) });
      }
      // A plain POST with checkout, same as the normal checkout button
      const f = document.createElement("form");
      f.method = "post"; f.action = T.routes.cart; f.hidden = true;
      f.innerHTML = '<input type="hidden" name="checkout" value="1">';
      document.body.append(f);
      f.submit();
    } catch (err) {
      // Nothing left the cart for good: put the stash back as it was
      before === null ? localStorage.removeItem(STASH) : localStorage.setItem(STASH, before);
      toast(err.message || T.strings.error);
      btn.disabled = false; btn.removeAttribute("aria-busy");
    }
  }

  async function restoreStash() {
    const raw = localStorage.getItem(STASH);
    if (raw === null) return;
    // Removed first, so a second tab or a failed add never adds the lines twice
    localStorage.removeItem(STASH);
    const s = parseStash(raw);
    if (!s || !s.items.length) return;
    let html;
    try {
      html = (await post(T.routes.cartAdd + ".js", { items: s.items })).sections;
    } catch {
      // One line may be sold out now; add the rest one by one
      for (const item of s.items) {
        try { html = (await post(T.routes.cartAdd + ".js", { items: [item] })).sections; } catch {}
      }
    }
    if (!html) return;
    if ($("[data-cart-page]") || location.pathname === T.routes.cart) location.reload();
    else renderDrawer(html["cart-drawer"]);
  }
  restoreStash();

  // ---------- Email forms: check the address, then let Shopify's form post ----------
  $$("[data-signup]").forEach(form => form.addEventListener("submit", e => {
    const input = $("input[type=email]", form);
    const msg = $("[data-signup-msg]", form);
    if (input && !/^\S+@\S+\.\S+$/.test(input.value.trim())) {
      e.preventDefault();
      if (msg) { msg.classList.add("is-error"); msg.textContent = T.strings.emailError; }
      input.setAttribute("aria-invalid", "true");
      input.focus();
    }
  }));

  // Country and language pickers post as soon as they change
  $$("[data-autosubmit]").forEach(sel => sel.addEventListener("change", () => sel.form && sel.form.submit()));

  // The free-shipping text is rendered in Liquid; money() is kept for app blocks that need it
  window.theme.money = money;
  window.theme.openCart = openDrawer;
})();
